<template>
  <GxxtCard
    class="p30 c-user"
    v-if="goodsType == constants.goodsType.offlineClass && uList.length>0"
  >
    <div class="c-avatar-list">
      <template v-for="(item,index) in uList" :key="index">
        <div class="c-avatar" v-if="index<7">
          <gxxt-avatar class="img" :size="52" :src="item.photo"></gxxt-avatar>
        </div>
      </template>
    </div>
    <div class="f26 color-888" @click="jumpToUserList()">
      最近参与用户
      <i class="iconfont icon-gengduoyonghu f24 color-888"></i>
    </div>
  </GxxtCard>
</template>

<script>
import { GxxtCard, GxxtAvatar } from '@/components'
import { onMounted, watch, ref, toRefs, getCurrentInstance } from 'vue'
import { getUserSignUpList } from '@/api/modules/course'
import { useRouter } from 'vue-router'
export default {
  components: {
    GxxtCard,
    GxxtAvatar,
  },
  setup(props) {
    const uList = ref([])
    const $router = useRouter()
    const currentInstance = getCurrentInstance()
    const global = currentInstance.appContext.config.globalProperties

    const getUserList = async () => {
      let res = await getUserSignUpList({
        courseId: props.resourceId,
      })
      if (res && res.code == 200) {
        uList.value = res.data
      }
    }
    const { resourceId } = toRefs(props)
    watch(resourceId, (newV, oldV) => {
      if (
        newV != oldV &&
        props.goodsType == global.constants.goodsType.offlineClass
      ) {
        getUserList()
      }
    })
    onMounted(() => {
      if (props.goodsType == global.constants.goodsType.offlineClass) {
        getUserList()
      }
    })

    const jumpToUserList = () => {
      $router.push({
        path: '/user-list',
        query: {
          id: props.resourceId,
          adminId: props.adminId,
        },
      })
    }
    return {
      jumpToUserList,
      uList,
    }
  },
  props: {
    goodsType: {
      type: [String, Number],
      default: '',
    },
    goodsId: {
      type: [String, Number],
      default: '',
    },
    resourceId: {
      type: [String, Number],
      default: '',
    },
    adminId: {
      type: [String, Number],
      default: '',
    },
  },
}
</script>

<style lang="less" scoped>
.c-user {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  position: relative;
  z-index: 1;
}
.c-avatar {
  display: inline-block;
  width: 52px;
  height: 52px;
  margin-left: -10px;
  img {
    width: 52px;
    height: 52px;
    box-shadow: -4px 0px 4px 0px rgba(192, 192, 192, 0.3);
    border-radius: 30px;
    border: 2px solid #ffffff;
    position: relative;
    margin-left: -10px;
  }
}
</style>